import type { EditorTranslationKey } from './translations/editor';

import { getActiveInterfaceLocale } from './locale';
import { translate } from './translations';

export const translateEditor = (key: EditorTranslationKey, variables?: Record<string, number | string>) =>
  translate(getActiveInterfaceLocale(), key, variables);
